// extracted by mini-css-extract-plugin
module.exports = {"root":"closedDataRequests_root__1ZEi6","description":"closedDataRequests_description__1m3Pm"};